import React, { useContext } from 'react';

import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';
import Ukopani from '@/models/groblja/ukopani';
import MapCentricPage from '@/ui/MapCentric/MapCentricPage';
import DataController from '@/lib/DataController';
import DialogContext from '@/context/DialogContext/DialogContext';
import GeneralTableDialog from '@/ui/Dialog/GeneralTableDialog';
import { DCRecord } from '@/@types/lib/dataController';
import { AllowRowActionFn } from '@/@types/ui/Table';
import AdvancedGrobljaDialog from '../RegistarKorisnika/AdvancedGrobljaDialog';

const RegistarUkopanihPage = () => {
  const dc = new DataController(Ukopani);

  const { showDialog } = useContext(DialogContext);

  const handleRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.ukopani_history',
        view: 'history',
        customPath: `${Ukopani.apiPath}/${id}/history`,
        tableId: 'ukopani-history',
      });
    }
  };

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    if (action === 'show_history' && record.has_history) {
      return true;
    }
    return false;
  };

  return (
    <AppPage titlett="groblja:titles.reg_ukopanih" needPermission={[Permissions.GrobljaManageOsnovniRegistri]}>
      <MapCentricPage
        model={Ukopani}
        titleToken="groblja:titles.reg_ukopanih"
        view="default"
        baseRecordPath=""
        mapId={45}
        mapModel={Ukopani}
        dialogComponent={AdvancedGrobljaDialog}
        allowAdd
        allowEdit
        onCustomTableAction={handleRowAction}
        allowCustomTableAction={allowRowAction}
        allowShowDeleted
        dialogTitle='titles.ukopani'
        allowExport
      />
    </AppPage>
  );
};

export default RegistarUkopanihPage;
